import { useQuery, UseQueryResult } from 'react-query';
import { GoogleCalendar } from 'types';
import { client } from 'utils/api-client';

function useGoogleCalendar(googleCalendarId?: string | null): UseQueryResult<{ data: GoogleCalendar }> {
  return useQuery(
    ['google-calendars', googleCalendarId],
    () => client.get(`google-calendars/${googleCalendarId}/`),
    {
      enabled: !!googleCalendarId,
    },
  );
}

export default useGoogleCalendar;
